module.exports = __webpack_public_path__ + "static/media/DroddIntro.5e9b5449.mp4";